// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rj3Hu","comment":"styles_comment__1hzhD"};